import {
  SERVER_DEV_URL,
  SERVER_STAGING_URL,
  SERVER_PROD_URL,
  CLIENT_STAGING_HOST,
  CLIENT_PROD_HOST,
} from "../config";

export const ENVIRONMENTS = {
  DEVELOPMENT: "development",
  STAGING: "staging",
  PRODUCTION: "production",
};

const API_BASE_URLS = {
  [ENVIRONMENTS.DEVELOPMENT]: SERVER_DEV_URL,
  [ENVIRONMENTS.STAGING]: SERVER_STAGING_URL,
  [ENVIRONMENTS.PRODUCTION]: SERVER_PROD_URL,
};

const detectEnvironmentByHostname = () => {
  if (typeof window === "undefined") {
    return ENVIRONMENTS.DEVELOPMENT;
  }

  const hostname = window.location.hostname;

  // Production
  if (hostname === CLIENT_PROD_HOST) {
    return ENVIRONMENTS.PRODUCTION;
  }

  // Staging
  if (hostname === CLIENT_STAGING_HOST) {
    return ENVIRONMENTS.STAGING;
  }

  // Local development
  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "0.0.0.0" ||
    hostname.endsWith(".local")
  ) {
    return ENVIRONMENTS.DEVELOPMENT;
  }

  // Any other real host (custom domain not yet configured, Netlify deploy
  // previews, branch deploys, *.netlify.app) must talk to the production API.
  // Falling back to DEVELOPMENT here would point a deployed site at
  // http://localhost:3123 and every request would fail.
  return ENVIRONMENTS.PRODUCTION;
};

export const isDevelopment = () => {
  return detectEnvironmentByHostname() === ENVIRONMENTS.DEVELOPMENT;
};

export const isStaging = () => {
  return detectEnvironmentByHostname() === ENVIRONMENTS.STAGING;
};

export const isProduction = () => {
  return detectEnvironmentByHostname() === ENVIRONMENTS.PRODUCTION;
};

export const getApiBaseUrl = () => {
  const environment = detectEnvironmentByHostname();
  return API_BASE_URLS[environment] || API_BASE_URLS[ENVIRONMENTS.DEVELOPMENT];
};

export const getApiConfig = (apiType) => {
  const environment = detectEnvironmentByHostname();
  const baseUrl =
    API_BASE_URLS[environment] || API_BASE_URLS[ENVIRONMENTS.DEVELOPMENT];
  const token = "";

  const apiPaths = {
    "legacy-timepieces": "/api/legacytimepiece/v1",
  };

  const apiBaseUrl = `${baseUrl}${apiPaths[apiType] || apiPaths["legacy-timepieces"]}`;

  const apiConfig = {
    baseURL: apiBaseUrl,
    timeout: 30000, // 30 seconds
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  return {
    ...apiConfig,
    headers: {
      ...apiConfig.headers,
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  };
};
